import PropTypes from 'prop-types';
import React from 'react';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './ExtraUserInformation.css';
import NustartAdditionalInformationFields from './NustartAdditionalInformationFields';

const NustarExtraInformation = ({ spartanUserType, ...props }) => (<ExtraUserInformationFormModal
    title="Welcome to NuStar Educational Services"
    subtitle="Please provide some additional information below to continue."
    {...props}
>
    <NustartAdditionalInformationFields spartanUserType={spartanUserType} />
    <p className={styles.info}>
        {'Submission of this form indicates your permission for NuStar Educational Services and its education partners to contact you by phone (including mobile), email, text and/or other means. You also understand that these calls may be generated using an automated dialing technology.'}
    </p>
</ExtraUserInformationFormModal>);

NustarExtraInformation.propTypes = {
    spartanUserType: PropTypes.number,
};

export default compose(
    connect(({ me, auth }) => ({
        show: (me && (!me.graduationYear
            || !me.streetAddress
            || !me.zip
            || !me.state
        ) && Number(auth.level) === 5),
        spartanUserType: get(me, 'spartanUserType'),
        initialValues: {
            mobilePhone: get(me, 'mobilePhone'),
            graduationYear: get(me, 'graduationYear'),
            streetAddress: get(me, 'streetAddress'),
            unit: get(me, 'unit'),
            city: get(me, 'city'),
            state: get(me, 'state'),
            zip: get(me, 'zip'),
        },
    })),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(NustarExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/NustarExtraInformation.js